import { truncateDoubleTo } from './truncateDoubleTo';

export function oddToString(odd) {
    if (odd > 100) {
        return truncateDoubleTo(parseFloat(odd / 100.00), 2)
    } else {
        return null;
    }
}
